export default {
  header: 'Login',
  placeholder: {
    username: "Benutzername",
    password: "Passwort"
  },
  action: {
    login: 'Login',
  },
  error: {
    username_or_password: "Benutzername oder Passwort ist falsch!"
  }
}
